/**
 * This project's tour placeholders: the records a "Show me" step can name as
 * `{name}` in its route (docs/SYSTEM.md → Show me tours). Each is looked up
 * live when the tour runs, never written into the entry (docs/LIVE-DATA.md).
 *
 * Imported once by main.tsx. A tour naming a placeholder that isn't
 * registered here fails changes.test.ts. A project replaces these examples
 * with its own records as it replaces the example screens.
 */
import { client } from '@/adapters/rpc/client'
import { registerTourPlaceholder } from '@/features/shared/components/tour/placeholders'

/** Any item at all — the newest page's first. Opens on /projects?item={item}. */
registerTourPlaceholder('item', async () => {
  const page = await client.items.list({ limit: 1 })
  return page.items[0]?.id ?? null
})

/** The next upcoming job — opens a job page with a full Activity log. Opens on /jobs/{job}. */
registerTourPlaceholder('job', async () => {
  const list = await client.jobs.list({ pageSize: 1 })
  return list.rows[0]?.id ?? null
})

/** The first client on the list — opens a client page with its location tabs. Opens on /clients/{client}. */
registerTourPlaceholder('client', async () => {
  const list = await client.clients.list({ pageSize: 1 })
  return list.rows[0]?.id ?? null
})

/** The first cleaner on the list — opens a cleaner page with a regular week. Opens on /cleaners/{cleaner}. */
registerTourPlaceholder('cleaner', async () => {
  const list = await client.cleaners.list()
  return list.rows.find((row) => !row.fillIn)?.id ?? null
})

/** The first invoice still owed — opens an invoice page with its reminders. Opens on /invoices/{invoice}. */
registerTourPlaceholder('invoice', async () => {
  const list = await client.invoices.list({ group: 'waiting', pageSize: 1 })
  return list.rows[0]?.id ?? null
})
